// JavaScript source code
/* eslint-disable */
import React from 'react';
import { BaseFilter, ShowTitleByTitle } from './Scaffolding';
import {
    TextField,
    BooleanField,
    DateField,
    ReferenceField,
    SimpleForm,
    Show,
    Create,
    Edit,
    SimpleShowLayout,
    Datagrid,
    ReferenceInput,
} from 'react-admin';
import { ASCcodeLabels } from './AscCode';
import { SwList } from '../lib/SwList';
import { useAzureADGroups } from '../msal/useAzureADGroups';
import { ReadOnlyContext } from '../lib/context/ReadOnlyContext';
import { EditToolbar } from '../layout/EditToolbar';
import {
    AutocompleteInput,
    BooleanInput,
    TextInput,
} from '../lib/wrappers/Inputs';

export const HecosCodeLabels = {
    pageTitle: 'HECOS Codes',
    Title: 'HECOS subject',
};

export const HECOScodeList = (props) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SwList
                {...props}
                title={HecosCodeLabels.pageTitle}
                filters={<BaseFilter />}
            >
                <Datagrid
                    rowClick="edit"
                    bulkActionButtons={!canEditStaticData ? false : undefined}
                >
                    <TextField source="id" />
                    <TextField label={HecosCodeLabels.Title} source="Title" />
                    <TextField source="code" />
                </Datagrid>
            </SwList>
        </ReadOnlyContext.Provider>
    );
};

export const HECOScodeCreate = (props) => (
    <Create {...props} redirect="edit">
        <HECOScodeInputs {...props} />
    </Create>
);

export const HECOScodeEdit = (props) => (
    <Edit title={<ShowTitleByTitle />} {...props} redirect="edit">
        <HECOScodeInputs {...props} />
    </Edit>
);

export const HECOScodeShow = (props) => (
    <Show title={<ShowTitleByTitle />} {...props}>
        <SimpleShowLayout>
            <TextField source="id" />
            <TextField source="Title" />
            <TextField source="code" />
            <BooleanField source="current" />
            <ReferenceField
                source="ascCode"
                reference="AscCode"
                label={ASCcodeLabels.Title}
                linkType="show"
                allowEmpty
            >
                <TextField source="description" />
            </ReferenceField>
            <TextField source="created_at" />
            <DateField source="updated_at" />
        </SimpleShowLayout>
    </Show>
);

const HECOScodeInputs = (source) => {
    const { canEditStaticData } = useAzureADGroups();
    return (
        <ReadOnlyContext.Provider value={!canEditStaticData}>
            <SimpleForm {...source} toolbar={<EditToolbar />}>
                <TextInput source="id" disabled />
                <TextInput label={HecosCodeLabels.Title} source="Title" />
                <TextInput source="code" />
                <ReferenceInput
                    source="ascCode"
                    reference="AscCode"
                    label={ASCcodeLabels.Title}
                    allowEmpty
                >
                    <AutocompleteInput optionText="description" />
                </ReferenceInput>
                <BooleanInput source="current" />
                <TextInput source="created_at" disabled />
                <TextInput source="updated_at" disabled />
            </SimpleForm>
        </ReadOnlyContext.Provider>
    );
};
